import { GridColDef } from "@mui/x-data-grid";
import ConfirmActionButton from "../../../components/Fleet/ConfirmActionButton/ConfirmActionButton";
import UpdateEmployeePopup from "../../../components/HR/UpdateEmployeePopup/UpdateEmployeePopup";
import { contractTypeLabels } from "../../HR/ContractType";
import { payFrequencyLabels } from "../../HR/PayFrequency";
import { employeeGenderLabel } from "../../HR/EmployeeGender";

export const employeesTableColumns: GridColDef[] = [
  { field: "firstName", headerName: "First Name", width: 180 },
  { field: "lastName", headerName: "Last Name", width: 180 },
  { field: "nickname", headerName: "Nickname", width: 160 },
  {
    field: "gender",
    headerName: "Gender",
    width: 150,
    valueFormatter: employeeGenderLabel,
  },
  { field: "position", headerName: "Position", width: 180 },
  { field: "legalPosition", headerName: "Legal Position", width: 200 },
  { field: "department", headerName: "Department", width: 180 },
  {
    field: "manager",
    headerName: "Reports To",
    width: 180,
    valueFormatter: (value: any) =>
      value && `${value.firstName + " " + value.lastName}`,
  },
  {
    field: "contractType",
    headerName: "Contract Type",
    width: 180,
    valueFormatter: (params: any) => {
      return params ? contractTypeLabels[params] || params : "";
    },
  },
  {
    field: "payFrequency",
    headerName: "Pay Frequency",
    width: 160,
    valueFormatter: (value: any) => {
      return value ? payFrequencyLabels[value] || value : "";
    },
  },
  { field: "employer", headerName: "Employer", width: 180 },

  {
    field: "startDate",
    headerName: "Contract Start Date",
    width: 180,
    valueFormatter: (value) => new Date(value as string).toLocaleDateString(),
  },
  {
    field: "terminationDate",
    headerName: "Contract End Date",
    width: 180,
    valueFormatter: (value) =>
      value ? new Date(value as string).toLocaleDateString() : "N/A",
  },
  { field: "email", headerName: "Email", width: 180 },
  { field: "phoneNumber", headerName: "Phone Number", width: 180 },
  { field: "workPhoneNumber", headerName: "Work Phone Number", width: 200 },
  {
    field: "birthDate",
    headerName: "Birth Date",
    width: 180,
    valueFormatter: (value) => new Date(value as string).toLocaleDateString(),
  },
  {
    field: "isMarried",
    headerName: "Is Married",
    width: 130,
    valueFormatter: (value) => (value === true ? "Yes" : "No"),
  },
  { field: "childrenCount", headerName: "Children Count", width: 150 },
  { field: "childrenSexes", headerName: "Children Sex", width: 180 },
  {
    field: "secondManager",
    headerName: "Second Manager",
    width: 180,
    valueFormatter: (value: any) =>
      value && `${value.firstName + " " + value.lastName}`,
  },
  {
    field: "isManager",
    headerName: "Is Manager",
    width: 180,
    valueFormatter: (value) => (value === true ? "Yes" : "No"),
  },
  {
    field: "deliveryUnit",
    headerName: "Delivery Unit",
    width: 180,
    valueFormatter: (value: any) => value && value.toUpperCase(),
  },
  { field: "employeeId", headerName: "Employee ID", width: 180 },
  {
    field: "update",
    headerName: "",
    width: 130,
    renderCell: (params) => <UpdateEmployeePopup employee={params.row} />,
  },
  {
    field: "delete",
    headerName: "",
    width: 130,
    renderCell: (params) =>
      params.row.terminationDate === null ? (
        <ConfirmActionButton
          id={params.row.id}
          entityType="Employee"
          actionType="delete"
          entityLabel="employee"
          queryKey="employees"
          buttonLabel="Delete"
          buttonColor="error"
        />
      ) : (
        <ConfirmActionButton
          id={params.row.id}
          entityType="Employee"
          actionType="restore"
          entityLabel="employee"
          queryKey="employees"
          buttonLabel="Restore"
          buttonColor="success"
        />
      ),
  },
];
